import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, Upload, Icon, notification, Row, Col, Typography, InputNumber, Carousel, Switch, DatePicker, Tag } from 'antd';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ApiCaller from '../../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';
import moment from 'moment';
import './EventHotelUpdate.css';

const { TextArea } = Input;
const { Text, Paragraph } = Typography;

@inject(
    'CmsLanguageStore',
    'CmsEventHotelStore'
)
@observer
class EventHotelUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
    }

    create = () => {
        this.props.CmsEventHotelStore.create().then(() => {
            this.props.CmsEventHotelStore.setupdateLoading(false);
            this.props.CmsEventHotelStore.setshowModal(false);
            this.props.CmsEventHotelStore.getAll();
        });
    }

    update = () => {
        this.props.CmsEventHotelStore.update().then(() => {
            this.props.CmsEventHotelStore.setupdateLoading(false);
            this.props.CmsEventHotelStore.setshowModal(false);
            this.props.CmsEventHotelStore.getAll();
        });
    }

    cancel = () => {
        this.props.CmsEventHotelStore.setshowModal(false);
    }

    // UPLOAD Settings

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file, id) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'You can only upload JPG/PNG file!',
                placement: 'bottomRight',
            })
        }

        const isLessThan10Mb = file.size / 1024 / 1024 < 1;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 1MB!',
                placement: 'bottomRight',
            })
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.CmsEventHotelStore.setImageIsLoadingById(id, true);
        }

        return isJpgOrPng && isLessThan10Mb
    }

    uploadChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.CmsEventHotelStore.setImageUrlById(id, '')
                return
            }
            if (info.file.status === 'done') {
                const category = 'HotelEvent'
                const titleName = title || 'Default'

                return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.CmsEventHotelStore.setImageUrlById(id, response.imageUrl)
                    this.props.CmsEventHotelStore.setImageIsLoadingById(id, false);
                })
            }
        }
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            eventHotel,
            updateLoading,
            images
        } = this.props.CmsEventHotelStore;

        let hasError = true;

        const defaultLang = eventHotel.eventHotelLanguages.find(fi => fi.languageId === 1);
        if (defaultLang) {
            hasError = images.length === 0 || defaultLang.title === '' || defaultLang.briefDescription === '' || defaultLang.description === '';
        }

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            {
                                eventHotel
                                    ?
                                    <>
                                        <Form layout='vertical'>

                                            {/* Title */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Title</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                eventHotel.eventHotelLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={2}
                                                                                                        value={eventHotel.eventHotelLanguages.find(fi => fi.languageId === lang.id).title}
                                                                                                        onChange={(e) => this.props.CmsEventHotelStore.settitle(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Brief Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Brief Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                eventHotel.eventHotelLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={3}
                                                                                                        value={eventHotel.eventHotelLanguages.find(fi => fi.languageId === lang.id).briefDescription}
                                                                                                        onChange={(e) => this.props.CmsEventHotelStore.setbriefDescription(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                eventHotel.eventHotelLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <CKEditor
                                                                                                        editor={ClassicEditor}
                                                                                                        data={eventHotel.eventHotelLanguages.find(fi => fi.languageId === lang.id).description}
                                                                                                        onChange={(event, editor) => {
                                                                                                            const data = editor.getData();
                                                                                                            this.props.CmsEventHotelStore.setdescription(lang.id, data)
                                                                                                        }}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>

                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Show Banner Only */}
                                            <>
                                                <Form.Item label='Show Banner Only'>
                                                    <Switch
                                                        checkedChildren='Yes'
                                                        unCheckedChildren='No'
                                                        checked={eventHotel.showBannerOnly}
                                                        onChange={(value) => this.props.CmsEventHotelStore.setshowBannerOnly(value)}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Show Date */}
                                            <>
                                                <Form.Item label='Show Date'>
                                                    <Switch
                                                        checkedChildren='Yes'
                                                        unCheckedChildren='No'
                                                        checked={eventHotel.showDate}
                                                        onChange={(value) => this.props.CmsEventHotelStore.setshowDate(value)}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Start Date Time */}
                                            <>
                                                <Form.Item label='Start Date Time'>
                                                    <DatePicker
                                                        size='default'
                                                        style={{ width: '65%', marginRight: 12 }}
                                                        format='DD MMM YYYY'
                                                        value={eventHotel.startDateObject}
                                                        onChange={(e) => this.props.CmsEventHotelStore.setstartDateObject(e)}
                                                    />
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardTimePicker
                                                            margin='dense'
                                                            ampm={false}
                                                            id='startdatetime-picker'
                                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                                            value={eventHotel.startTimeObject}
                                                            onChange={(e) => this.props.CmsEventHotelStore.setstartTimeObject(e)}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change time',
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Form.Item>
                                            </>

                                            {/* End Date Time */}
                                            <>
                                                <Form.Item label='End Date Time'>
                                                    <DatePicker
                                                        size='default'
                                                        style={{ width: '65%', marginRight: 12 }}
                                                        format='DD MMM YYYY'
                                                        value={eventHotel.endDateObject}
                                                        onChange={(e) => this.props.CmsEventHotelStore.setendDateObject(e)}
                                                    />
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardTimePicker
                                                            margin='dense'
                                                            ampm={false}
                                                            id='enddatetime-picker'
                                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                                            value={eventHotel.endTimeObject}
                                                            onChange={(e) => this.props.CmsEventHotelStore.setendTimeObject(e)}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change time',
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Form.Item>
                                            </>

                                            {/* Sort */}
                                            <>
                                                <Form.Item label='Sort'>
                                                    <InputNumber
                                                        className='stm-width-100'
                                                        value={eventHotel.sort}
                                                        onChange={(value) => this.props.CmsEventHotelStore.setsort(value)}
                                                        min={1}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Banner */}
                                            <>
                                                {
                                                    images.map(image => {
                                                        return (
                                                            <Form.Item key={image.id} label={
                                                                image.url === ''
                                                                    ?
                                                                    'Create Banner (Minimum resolution: 640x480)'
                                                                    :
                                                                    <>
                                                                        <Row className='updatehotelevent-row-label'>
                                                                            <Col span={12} className='updatehotelevent-col-label'>Update Banner (Minimum resolution: 640x480)</Col>
                                                                            <Col span={12} className='updatehotelevent-col-label-button'>
                                                                                <Button type='danger' onClick={() => this.props.CmsEventHotelStore.removeImageById(image.id)}>Delete</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                            }>
                                                                <Upload
                                                                    listType='picture-card'
                                                                    className='avatar-uploader'
                                                                    showUploadList={false}
                                                                    customRequest={this.dummyRequest}
                                                                    beforeUpload={(info) => this.beforeUpload(info, image.id)}
                                                                    onChange={(info) => this.uploadChange(info, image.id, 'EventHotel')}
                                                                >
                                                                    {
                                                                        image.url !== ''
                                                                            ?
                                                                            <img src={image.url} alt='avatar' className='updatehotelevent-img' />
                                                                            :
                                                                            <div>
                                                                                <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                                <div className='ant-upload-text'>Upload</div>
                                                                            </div>}
                                                                </Upload>
                                                            </Form.Item>
                                                        )
                                                    })
                                                }
                                            </>

                                            {/* Preview */}
                                            <>
                                                <Form.Item label='Preview Banner'>
                                                    <Row>
                                                        <Col span={24} className='updatehotelevent-col-preview-container'>
                                                            {
                                                                images.length === 1
                                                                    ?
                                                                    null
                                                                    :
                                                                    <Row>
                                                                        <Col className='updatehotelevent-col-preview-img'>
                                                                            <>
                                                                                <Row>
                                                                                    <Col
                                                                                        span={24}
                                                                                        className={images.length === 2 ? 'updatehotelevent-col-carousel-container-single' : 'updatehotelevent-col-carousel-container'}
                                                                                    >
                                                                                        <Carousel>
                                                                                            {
                                                                                                images.filter(fi => fi.url !== '').map(image => {
                                                                                                    return (
                                                                                                        <div key={image.id} className='updatehotelevent-div-carousel'>
                                                                                                            <Row className='updatehotelevent-row-carousel'>
                                                                                                                <Col span={24} className='updatehotelevent-col-carousel'>
                                                                                                                    <img className='updatehotelevent-img-carousel' src={image.url} alt={image.id} />
                                                                                                                </Col>
                                                                                                            </Row>
                                                                                                        </div>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </Carousel>
                                                                                    </Col>
                                                                                </Row>
                                                                            </>
                                                                            <>
                                                                                {
                                                                                    eventHotel.showBannerOnly
                                                                                        ?
                                                                                        null
                                                                                        :
                                                                                        <>
                                                                                            {
                                                                                                eventHotel.eventHotelLanguages.find(fi => fi.languageId === 1)
                                                                                                    ?
                                                                                                    <>
                                                                                                        <Row className='updatehotelevent-row-detail'>
                                                                                                            <Col span={24} className='updatehotelevent-col-preview-title'>
                                                                                                                <Text className='updatehotelevent-text-preview-title'>{eventHotel.eventHotelLanguages.find(fi => fi.languageId === 1).title}</Text>
                                                                                                            </Col>
                                                                                                            <>
                                                                                                                {
                                                                                                                    eventHotel.showDate
                                                                                                                        ?
                                                                                                                        <>
                                                                                                                            <Col span={24} className='updatehotelevent-col-preview-date'>
                                                                                                                                <Row>
                                                                                                                                    <Col span={11} className='txt-algn-right'>
                                                                                                                                        <Tag color={'blue'} className='fnt-8 mg-0' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                                                                            <Text>{moment(eventHotel.startDate).format("DD MMMM YYYY")}</Text>
                                                                                                                                        </Tag>
                                                                                                                                    </Col>
                                                                                                                                    <Col span={2} className='txt-algn-center'>
                                                                                                                                        <Text>-</Text>
                                                                                                                                    </Col>
                                                                                                                                    <Col span={11}>
                                                                                                                                        <Tag color={'blue'} className='fnt-8' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                                                                            <Text>{moment(eventHotel.endDate).format("DD MMMM YYYY")}</Text>
                                                                                                                                        </Tag>
                                                                                                                                    </Col>
                                                                                                                                </Row>
                                                                                                                            </Col>
                                                                                                                        </>
                                                                                                                        :
                                                                                                                        null
                                                                                                                }
                                                                                                            </>
                                                                                                            <Paragraph className='clr-theme-dark-1'>
                                                                                                                <Markup content={eventHotel.eventHotelLanguages.find(fi => fi.languageId === 1).description} />
                                                                                                            </Paragraph>
                                                                                                        </Row>
                                                                                                    </>
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                }
                                                                            </>

                                                                        </Col>
                                                                    </Row>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                            </>

                                            {/* Button */}
                                            <>
                                                <Form.Item>
                                                    {
                                                        eventHotel.id === 0
                                                            ?
                                                            <Button onClick={this.create} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Create</Button>
                                                            :
                                                            <Button onClick={this.update} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Update</Button>
                                                    }

                                                    <Button onClick={this.cancel}>Cancel</Button>
                                                </Form.Item>
                                            </>
                                        </Form>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default EventHotelUpdate;